const LINKS = [
    ['Email', 'mailto:jonathqncjr@gmail.com'],
    ['LinkedIn', 'https://www.linkedin.com/in/jonathanedw05/'],
    // Taken from the repo links in projects.json, the URL supplied was a second
    // copy of the LinkedIn one. Worth confirming.
    ['GitHub', 'https://github.com/AtlasCJr'],
    ['Résumé', '/resume.pdf'],
];

export default function ContactView({ style, children, active, mobile }) {
    return (
        <div inert={!active} aria-hidden={!active} style={{ ...style, ...(mobile ? { textAlign: 'center', justifyContent: 'flex-start', overflowY: 'auto' } : {}) }}>
            <div className={mobile ? 'sig-centered-content' : undefined} style={mobile ? undefined : { display: 'contents' }}>
            {/* the availability chip, on layouts with nowhere else to put it */}
            {children}
            <div
                style={{
                    display: 'flex',
                    justifyContent: mobile ? 'center' : 'flex-end',
                    flexWrap: 'wrap',
                    gap: mobile ? '0 18px' : '22px',
                    fontSize: mobile ? '12px' : '13px',
                }}
            >
                {/* Resting opacity lives on each link, not the row, a parent's opacity
                        would cap the children and stop hover from reaching full strength. */}
                {LINKS.map(([label, href]) => (
                    <a
                        key={label}
                        href={href}
                        target={href.startsWith('mailto:') ? undefined : '_blank'}
                        rel="noopener noreferrer"
                        className="sig-link"
                    >
                        {label}
                    </a>
                ))}
            </div>
            <div style={{ fontSize: mobile ? '11px' : '12px', opacity: mobile ? 0.65 : 0.4, marginTop: mobile ? '8px' : '12px' }}>
                Jakarta, Indonesia · GMT+7
            </div>
            </div>
        </div>
    );
}
